import { DateTime } from "luxon";

export const CATEGORIE_LABELS = {
  ORIENTATION: "Orientation",
  RDO: "RDO",
  RDV: "Rendez-vous",
  CER: "CER",
  SANCTION: "Sanction",
};

export const TYPE_LABELS = {
  CALCULER_ORIENTATION: "Calcul de l'orientation",
  FORCER_ORIENTATION: "Orientation forcée",
  DECIDER_ORIENTATION: "Décision d'orientation",
  MODIFIER_ORIENTATION: "Modification d'orientation",
  MAINTIEN_ORIENTATION: "Maintien d'orientation",
  CREER_RDV: "Création de rendez-vous",
  ANNULER_RDV: "Annulation de rendez-vous",
  TERMINER_RDV: "Clôture de rendez-vous",
  SIGNER_CER: "Signature CER",
  REFUSER_CER: "Refus CER",
  SIGNER_AVENANT_CER: "Signature avenant CER",
  REFUSER_AVENANT_CER: "Refus avenant CER",
  MIGRATION_LEGACY: "Migration legacy",
  REMONTER_DECISION_SANCTION: "Décision de sanction remontée à France Travail",
  DEMANDER_RADIATION_SANCTION: "Demande de radiation de la liste des demandeurs d'emploi",
};

export const PARCOURS_LABELS = {
  PED: "Parcours professionnel",
  PSP: "Parcours socio-professionnel",
  PSO: "Parcours social",
  EO: "Entretien d'orientation",
  IND: "Indéterminé",
};

const formatParcours = (value) =>
  value == null ? value : (PARCOURS_LABELS[value] ?? value);

export const STATUT_PRESENTATION = {
  DONE: { label: "Synchronisé", color: "success", icon: "check-circle" },
  PENDING: { label: "En attente", color: "warning", icon: "clock-o" },
  ERROR: { label: "En erreur", color: "danger", icon: "exclamation-triangle" },
};

export function getTypeLabel(type) {
  return TYPE_LABELS[type] ?? type;
}

export function formatSynchroFTData(type, data) {
  if (!data) return [];

  switch (type) {
    case "DECIDER_ORIENTATION":
      return [
        { label: "Orientation FT", value: data.orientationFT },
        { label: "Orientation ESPOAR", value: data.orientationEspoar },
        { label: "Acceptée", value: data.orientationAcceptee ? "Oui" : "Non" },
        data.parcours && { label: "Parcours", value: formatParcours(data.parcours) },
      ].filter(Boolean);

    case "FORCER_ORIENTATION":
      return [
        { label: "Orientation", value: data.orientation },
        data.parcours && { label: "Parcours", value: formatParcours(data.parcours) },
        { label: "Origine", value: data.origine },
        data.orienteLe && {
          label: "Orienté le",
          value: DateTime.fromISO(data.orienteLe).toFormat("dd/MM/yyyy"),
        },
      ].filter(Boolean);

    case "MODIFIER_ORIENTATION":
      return [
        { label: "Orientation", value: data.orientation },
        data.parcours && { label: "Parcours", value: formatParcours(data.parcours) },
      ].filter(Boolean);

    case "MAINTIEN_ORIENTATION":
      return [{ label: "Orientation", value: data.orientation }];

    case "CALCULER_ORIENTATION":
      return [{ label: "RDO", value: data.rdoId }];

    case "CREER_RDV":
      return [{ label: "RDV France Travail", value: data.rdvFTId }];

    case "ANNULER_RDV":
      return [];

    case "TERMINER_RDV":
      return [{ label: "Type de clôture", value: String(data.typeClotureRdv) }];

    // Sanctions RSA (lot 2) : ce que France Travail a reçu et ce qu'il en a fait.
    case "REMONTER_DECISION_SANCTION":
      return [
        { label: "Décision", value: data.decision },
        { label: "Prise en compte par France Travail", value: data.priseEnCompte ? "Oui" : "Non" },
        { label: "Code retour", value: data.codeSortie },
        { label: "Sanction France Travail", value: data.idConsequenceSanction },
      ];

    case "DEMANDER_RADIATION_SANCTION":
      return [
        { label: "Radiation créée", value: data.effectuee ? "Oui" : "Non" },
        { label: "Code retour", value: data.codeSortie },
        { label: "Sanction France Travail", value: data.idConsequenceSanction },
      ];

    default:
      return Object.entries(data).map(([label, value]) => ({
        label,
        value:
          typeof value === "object" ? JSON.stringify(value) : String(value),
      }));
  }
}
